var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"title":"Повторить задачу","ok-title":"Выполнить сейчас","header-bg-variant":"success","header-text-variant":"light","ok-variant":"success"},on:{"ok":_vm.confirm}},[_c('p',[_vm._v("Эта задача будет выполнена прямо сейчас. Вы уверены?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }